<template>
  <div class="m-b-40">
    <div class="title-progress m-l-15 m-b-15">{{ item.name }}</div>
    <div class="m-l-15">
      <div class="d-flex align-center">
        <div class="progress-label m-r-5">Visit</div>
        <div class="progress-container-max">
          <div class="progress-container" :style="visitBoxWidth">
            <div class="progress-value-gray" :style="visitValueWidth">
              <span>{{ visit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-center m-t-5">
        <div class="progress-label m-r-5">Exit</div>
        <div class="progress-container-max">
          <div class="progress-container" :style="exitBoxWidth">
            <div class="progress-value-red" :style="exitValueWidth">
              <span>{{ exit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    total: Number,
    item: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    item: {
      deep: true,
      handler() {
        const exit = _.find(this.item.child, o => {
          return o.name === 'Ended By User'
        })
        this.visit = this.item.visit
        this.exit = exit ? exit.visit : 0

        this.max = Math.max(this.total, this.visit)

        this.visitBoxWidth = {
          width: `${Math.round((this.total * 100) / this.max)}%`
        }
        this.visitValueWidth = {
          width: `${Math.round((this.visit * 100) / this.total)}%`
        }
        this.exitBoxWidth = {
          width: `${Math.round((this.total * 100) / this.max)}%`
        }
        this.exitValueWidth = {
          width: `${Math.round((this.exit * 100) / this.total)}%`
        }
      }
    }
  },
  data() {
    return {
      max: 0,
      visit: 0,
      exit: 0,
      visitBoxWidth: { width: '100%' },
      visitValueWidth: { width: '0%' },
      exitBoxWidth: { width: '100%' },
      exitValueWidth: { width: '0%' }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-progress {
  color: #333333;
  font-weight: 800;
  font-size: 18px;
}

.progress-label {
  width: 30px;
  text-align: right;
  font-size: 0.875rem;
}

.progress-container-max {
  height: 18px;
  width: 100%;
  background: white;

  .progress-container {
    height: 18px;
    background: #d9d9d9;

    .progress-value-gray,
    .progress-value-red {
      height: 18px;
      line-height: 18px;
      color: white;
      text-align: right;
      font-size: 0.875rem;
      transition: width 0.8s;

      span {
        margin-right: 5px;
      }
    }
    .progress-value-gray {
      background: #666666;
    }

    .progress-value-red {
      background: $primary;
    }
  }
}
</style>
